const getText = (value, lang) => {
  //let lang = 'en'; //global.lang;
  //if (lang === undefined || lang === null) {
    lang = "fa";
 // }
  switch (value) {
    case "addsubanswer": {
      if (lang.toLowerCase() === "en") {
        return "Add sub answer";
      } else {
        return "افزودن پاسخ زیرشاخه";
      }
    }
    case "container": {
      if (lang.toLowerCase() === "en") {
        return "container";
      } else {
        return " نگهدارنده";
      }
    }
    case "containerend": {
      if (lang.toLowerCase() === "en") {
        return "End of ontainer";
      } else {
        return "پایان نگهدارنده";
      }
    }
    case "defulatopen": {
      if (lang.toLowerCase() === "en") {
        return "Open by default";
      } else {
        return "باز بودن بصورت پیشفرض ";
      }
    }

    case "multimode": {
      if (lang.toLowerCase() === "en") {
        return "Multi Select For Main Choice List";
      } else {
        return "چند انتخاب برای فهرست انتخاب اصلی";
      }
    }
    case "multiModeVirgul": {
      if (lang.toLowerCase() === "en") {
        return "Display Virgul in Multi select ";
      } else {
        return "نمایش ویرگول در چند انتخابی ";
      }
    }
    case "mainAnswerInMultiMode": {
      if (lang.toLowerCase() === "en") {
        return "Display Main Option in Multi select ";
      } else {
        return "نمایش گزینه مادر در چند انتخابی ";
      }
    }
    case "multisub": {
      if (lang.toLowerCase() === "en") {
        return "Multi select Sub Answers";
      } else {
        return "چند انتخابی در زیرگزینه ها";
      }
    }





    case "generalerror": {
      if (lang.toLowerCase() === "en") {
        return `An error occurred while processing the request. 
        It is possible that the error is from the network.
         Please try again and contact the system support if you encounter problems again`;
      } else {
        return `خطایی در انجام درخواست رخ داده است.
         این امکان وجود دارد که خطا از شبکه باشد. 
        لطفا یک بار دیگر امتحان کنید و اگر باز با مشکل مواجه شدید با پشتیبان سامانه تماس بگیرید`;
      }
    }
    case "lang": {
      if (lang.toLowerCase() === "en") {
        return "نمایش به زبان فارسی";
      } else {
        return "Display in english";
      }
    }
    case "loading": {
      if (lang.toLowerCase() === "en") {
        return "please waite ...";
      } else {
        return "لطفا کمی صبر کنید";
      }
    }
    case "starttext": {
      if (lang.toLowerCase() === "en") {
        return "start text";
      } else {
        return "متن شروع";
      }
    }
    case "start": {
      if (lang.toLowerCase() === "en") {
        return "start ";
      } else {
        return " شروع";
      }
    }
    case "end": {
      if (lang.toLowerCase() === "en") {
        return "end ";
      } else {
        return " پایان";
      }
    }
    case "addnewpagecategory": {
      if (lang.toLowerCase() === "en") {
        return "NEW CATEGORY";
      } else {
        return "دسته بندی جدید";
      }
    }
    case "titleoption": {
      if (lang.toLowerCase() === "en") {
        return "Title of option";
      } else {
        return "عنوان گزینه";
      }
    }

    case "addtopage": {
      if (lang.toLowerCase() === "en") {
        return "Add to page";
      } else {
        return "افزودن به صفحه";
      }
    }
    case "addnewitem": {
      if (lang.toLowerCase() === "en") {
        return "Add New";
      } else {
        return "جدید";
      }
    }
    case "addnewform": {
      if (lang.toLowerCase() === "en") {
        return "Add New Form Category";
      } else {
        return "افزودن دسته بندی فرم جدید";
      }
    }
    case "addnewitem": {
      if (lang.toLowerCase() === "en") {
        return "Add New item";
      } else {
        return "افزودن آیتم جدید";
      }
    }
    case "titles": {
      if (lang.toLowerCase() === "en") {
        return "Titles";
      } else {
        return " بخش ها ";
      }
    }
    case "title": {
      if (lang.toLowerCase() === "en") {
        return "Title";
      } else {
        return " عنوان ";
      }
    }
    case "addnewtitle": {
      if (lang.toLowerCase() === "en") {
        return "Add New Title";
      } else {
        return "افزودن عنوان جدید";
      }
    }
    case "edittitle": {
      if (lang.toLowerCase() === "en") {
        return "Edit Title";
      } else {
        return "ویرایش عنوان ";
      }
    }
    case "gotonextpage": {
      if (lang.toLowerCase() === "en") {
        return "Go to next page";
      } else {
        return "صفحه بعدی";
      }
    }
    case "report": {
      if (lang.toLowerCase() === "en") {
        return "Report";
      } else {
        return "گزارش";
      }
    }
    case "unequal": {
      if (lang.toLowerCase() === "en") {
        return "Unequal";
      } else {
        return "نامساوی";
      }
    }
    case "getreportfile": {
      if (lang.toLowerCase() === "en") {
        return "Get the report file";
      } else {
        return " دریافت فایل گزارش";
      }
    }

    case "equal": {
      if (lang.toLowerCase() === "en") {
        return "equal";
      } else {
        return "مساوی";
      }
    }
    case "editform": {
      if (lang.toLowerCase() === "en") {
        return "Edit Form Category";
      } else {
        return "ویرایش دسته بندی فرم ";
      }
    }
    case "formtype": {
      if (lang.toLowerCase() === "en") {
        return "Category Type";
      } else {
        return "نوع دسته بندی ";
      }
    }
    case "usernamemobile": {
      if (lang.toLowerCase() === "en") {
        return "Username (mobile without zero)";
      } else {
        return "نام کاربری(شماره موبایل بدون صفر)";
      }
    }
    case "getcode": {
      if (lang.toLowerCase() === "en") {
        return "Get Code";
      } else {
        return "دریافت کد";
      }
    }
    case "questiontype": {
      if (lang.toLowerCase() === "en") {
        return "Question Type";
      } else {
        return "نوع سوال ";
      }
    }
    case "questioncode": {
      if (lang.toLowerCase() === "en") {
        return "Question Code";
      } else {
        return "کد سوال ";
      }
    }
    case "tooltip": {
      if (lang.toLowerCase() === "en") {
        return "Tooltip";
      } else {
        return "راهنما ";
      }
    }
    case "numeric": {
      if (lang.toLowerCase() === "en") {
        return "Numeric";
      } else {
        return "نمره ";
      }
    }
    case "startform": {
      if (lang.toLowerCase() === "en") {
        return "Start from";
      } else {
        return "شروع فرم ";
      }
    }
    case "subform": {
      if (lang.toLowerCase() === "en") {
        return "Sub category";
      } else {
        return " دسته بندی فرعی ";
      }
    }
    case "mainform": {
      if (lang.toLowerCase() === "en") {
        return "Main category";
      } else {
        return " دسته بندی اصلی ";
      }
    }
    case "tosubform": {
      if (lang.toLowerCase() === "en") {
        return " to go to Sub Form";
      } else {
        return " برای رفتن به فرم فرعی ";
      }
    }
    case "helpform": {
      if (lang.toLowerCase() === "en") {
        return "Help page";
      } else {
        return "صفحه کمکی";
      }
    }
    case "helplabletext": {
      if (lang.toLowerCase() === "en") {
        return "Help lable text";
      } else {
        return " برچسب راهنما ";
      }
    }
    case "round": {
      if (lang.toLowerCase() === "en") {
        return "round";
      } else {
        return " گرد کردن ";
      }
    }
    case "floatcount": {
      if (lang.toLowerCase() === "en") {
        return "Float count";
      } else {
        return " شمارش شناور ";
      }
    }
    case "attachitemsfromexcellfile": {
      if (lang.toLowerCase() === "en") {
        return " Attach items from excell file";
      } else {
        return "الصاق آیتم از فایل اکسل";
      }
    }
    case "emptyexcellfile": {
      if (lang.toLowerCase() === "en") {
        return "Please select the Excel file";
      } else {
        return "لطفا فایل اکسل را انتخاب نمایید";
      }
    }
    case "downloadsamplefile": {
      if (lang.toLowerCase() === "en") {
        return "Download sample file";
      } else {
        return "دانلود فایل نمونه";
      }
    }
    case "formula": {
      if (lang.toLowerCase() === "en") {
        return " Formula";
      } else {
        return "فرمول ";
      }
    }
    case "displaysize": {
      if (lang.toLowerCase() === "en") {
        return "Display size";
      } else {
        return "اندازه فیلد ";
      }
    }
    case "answerdisplaysize": {
      if (lang.toLowerCase() === "en") {
        return "Options display size";
      } else {
        return "اندازه گزینه های فیلد ";
      }
    }
    case "displaytype": {
      if (lang.toLowerCase() === "en") {
        return "Title display type";
      } else {
        return "نوع نمایش عنوان فیلد ";
      }
    }
    case "formulaorques": {
      if (lang.toLowerCase() === "en") {
        return " Formula/questions";
      } else {
        return "فرمول/سوالات ";
      }
    }
    case "Operand": {
      if (lang.toLowerCase() === "en") {
        return " Operand";
      } else {
        return "عملوند ";
      }
    }
    case "endofconditions": {
      if (lang.toLowerCase() === "en") {
        return " end of conditions";
      } else {
        return "پایان شرایط ";
      }
    }
    case "startofconditions": {
      if (lang.toLowerCase() === "en") {
        return " start of conditions";
      } else {
        return "شروع شرایط ";
      }
    }
    case "description": {
      if (lang.toLowerCase() === "en") {
        return "description";
      } else {
        return "توضیحات";
      }
    }
    case "reload": {
      if (lang.toLowerCase() === "en") {
        return "Reload";
      } else {
        return "بازیابی";
      }
    }
    case "conditionforgoingto": {
      if (lang.toLowerCase() === "en") {
        return "Condition for going to";
      } else {
        return "شرط رفتن به";
      }
    }
    case "conditionforsend": {
      if (lang.toLowerCase() === "en") {
        return "Condition for sending to";
      } else {
        return "شروط ارسال به";
      }
    }
    case "operator": {
      if (lang.toLowerCase() === "en") {
        return " Operator";
      } else {
        return "اپراتور ";
      }
    }
    case "amountof": {
      if (lang.toLowerCase() === "en") {
        return " the amount of";
      } else {
        return "مقدار ";
      }
    }
    case "withnextcondition": {
      if (lang.toLowerCase() === "en") {
        return "with next condition";
      } else {
        return "شرط بعدی ";
      }
    }
    case "and": {
      if (lang.toLowerCase() === "en") {
        return "and";
      } else {
        return "و ";
      }
    }
    case "or": {
      if (lang.toLowerCase() === "en") {
        return "or";
      } else {
        return "یا ";
      }
    }
    case "listofquestions": {
      if (lang.toLowerCase() === "en") {
        return "List of questions";
      } else {
        return "لیست سوالات ";
      }
    }
    case "listofconditions": {
      if (lang.toLowerCase() === "en") {
        return "List of conditions";
      } else {
        return "لیست شرایط ";
      }
    }

    case "selectanswers": {
      if (lang.toLowerCase() === "en") {
        return "please select answer item";
      } else {
        return "لطفا گزینه پاسخ را انتخاب کنید ";
      }
    }
    case "answers": {
      if (lang.toLowerCase() === "en") {
        return "Answers";
      } else {
        return "پاسخ ها ";
      }
    }
    case "answeritem": {
      if (lang.toLowerCase() === "en") {
        return "Answer item";
      } else {
        return "پاسخ آیتم ";
      }
    }
    case "value": {
      if (lang.toLowerCase() === "en") {
        return "Value";
      } else {
        return "ارزش";
      }
    }
    case "resultform": {
      if (lang.toLowerCase() === "en") {
        return "Result category";
      } else {
        return "دسته بندی نتیجه ";
      }
    }
    case "showforsecretary": {
      if (lang.toLowerCase() === "en") {
        return "Show for secretary";
      } else {
        return "نمایش برای منشی ";
      }
    }
    case "questionfromlist": {
      if (lang.toLowerCase() === "en") {
        return "Add new question from list";
      } else {
        return "اضافه کردن سوال از لیست ";
      }
    }
    case "addnewquestion": {
      if (lang.toLowerCase() === "en") {
        return "Add new question";
      } else {
        return "افزودن سوال جدید  ";
      }
    }
    case "questions": {
      if (lang.toLowerCase() === "en") {
        return "Questions";
      } else {
        return "سوالات";
      }
    }
    case "validationusername": {
      if (lang.toLowerCase() === "en") {
        return "Please Insert username";
      } else {
        return "لطفا نام کاربری را وارد کنید";
      }
    }
    case "addnewpage": {
      if (lang.toLowerCase() === "en") {
        return "Add New Page";
      } else {
        return "افزودن صفحه جدید";
      }
    }

    case "editpage": {
      if (lang.toLowerCase() === "en") {
        return "Edit Page";
      } else {
        return "ویرایش صفحه ";
      }
    }
    case "restextpossition": {
      if (lang.toLowerCase() === "en") {
        return "position of text in result page";
      } else {
        return "محل قرار گیری متن در صفحه خلاصه پرونده";
      }
    }
    case "resultpageconditions": {
      if (lang.toLowerCase() === "en") {
        return "result page conditions";
      } else {
        return "نتایج صفحه شرایط ";
      }
    }
    case "top": {
      if (lang.toLowerCase() === "en") {
        return "Top";
      } else {
        return "بالا ";
      }
    }
    case "bot": {
      if (lang.toLowerCase() === "en") {
        return "bottom";
      } else {
        return "پایین ";
      }
    }
    case "calculationof": {
      if (lang.toLowerCase() === "en") {
        return "Calculation of :";
      } else {
        return "محاسبه ";
      }
    }
    case "textwithoutcondition": {
      if (lang.toLowerCase() === "en") {
        return "Text without condition";
      } else {
        return "متن بدون شرط ";
      }
    }
    case "validationusername": {
      if (lang.toLowerCase() === "en") {
        return "Please Insert username";
      } else {
        return "لطفا نام کاربری را وارد کنید";
      }
    }
    case "validationpassword": {
      if (lang.toLowerCase() === "en") {
        return "Please Insert Password";
      } else {
        return "لطفا کلمه عبور را وارد کنید";
      }
    }
    case "validationcellnumber": {
      if (lang.toLowerCase() === "en") {
        return "Please Insert Cellnumber";
      } else {
        return "لطفا موبایل خود را وارد کنید";
      }
    }
    case "validationemail": {
      if (lang.toLowerCase() === "en") {
        return "invalid email address";
      } else {
        return "آدرس ایمیل اشتباه است";
      }
    }
    case "validationpassword": {
      if (lang.toLowerCase() === "en") {
        return "Please Insert Password";
      } else {
        return "لطفا کلمه عبور را وارد کنید";
      }
    }
    case "addnewitem": {
      if (lang.toLowerCase() === "en") {
        return "Add New";
      } else {
        return "جدید";
      }
    }
    case "row": {
      if (lang.toLowerCase() === "en") {
        return "Row";
      } else {
        return "ردیف";
      }
    }
    case "text": {
      if (lang.toLowerCase() === "en") {
        return "text";
      } else {
        return "متن";
      }
    }

    case "adduser": {
      if (lang.toLowerCase() === "en") {
        return "Add User";
      } else {
        return "کاربر جدید";
      }
    }

    case "today": {
      if (lang.toLowerCase() === "en") {
        return "Today";
      } else {
        return "امروز";
      }
    }
    case "camera": {
      if (lang.toLowerCase() === "en") {
        return "Camera";
      } else {
        return "دوربین";
      }
    }
    case "gallery": {
      if (lang.toLowerCase() === "en") {
        return "Gallery";
      } else {
        return "گالری تصاویر";
      }
    }
    case "ok": {
      if (lang.toLowerCase() === "en") {
        return "Ok";
      } else {
        return "بسیار خوب";
      }
    }
    case "clearonload": {
      if (lang.toLowerCase() === "en") {
        return "Clear on page load";
      } else {
        return "پاکسازی هنگام لود  صفحه";
      }
    }
    case "defaultvalue": {
      if (lang.toLowerCase() === "en") {
        return "Default answer";
      } else {
        return "انتخاب پیشفرض";
      }
    }

    case "existedtext": {
      if (lang.toLowerCase() === "en") {
        return "This text is already registered";
      } else {
        return "این متن قبلا ثبت شده است";
      }
    }
    case "existedCode": {
      if (lang.toLowerCase() === "en") {
        return "This code is already registered";
      } else {
        return "این کد قبلا ثبت شده است";
      }
    }
    case "existedcapsule": {
      if (lang.toLowerCase() === "en") {
        return "this capsule already stored";
      } else {
        return "این کپسول قبلاً ذخیره شده است";
      }
    }
    case "existedtitle": {
      if (lang.toLowerCase() === "en") {
        return "this title already stored";
      } else {
        return "این عنوان قبلاً ذخیره شده است";
      }
    }
    case "changepermissiontouser": {
      if (lang.toLowerCase() === "en") {
        return "User";
      } else {
        return " کاربر";
      }
    }
    case "changepermissiontoadmin": {
      if (lang.toLowerCase() === "en") {
        return " Admin";
      } else {
        return "مدیر";
      }
    }
    case "changepermissiontoassistant": {
      if (lang.toLowerCase() === "en") {
        return " assistant";
      } else {
        return "دستیار";
      }
    }
    case "admin": {
      if (lang.toLowerCase() === "en") {
        return "Admin";
      } else {
        return "مدیر";
      }
    }
    case "role": {
      if (lang.toLowerCase() === "en") {
        return "Role";
      } else {
        return "نقش";
      }
    }
    case "userpermission": {
      if (lang.toLowerCase() === "en") {
        return "Permissions";
      } else {
        return "مجوزهای کاربر";
      }
    }
    case "insertsuccesfully": {
      if (lang.toLowerCase() === "en") {
        return "Insert Succesfully";
      } else {
        return "ثبت اطلاعات با موفقیت انجام شد";
      }
    }
    case "editsuccesfully": {
      if (lang.toLowerCase() === "en") {
        return "Edit Succesfully";
      } else {
        return "ویرایش با موفقیت انجام شد";
      }
    }
    case "existedregister": {
      if (lang.toLowerCase() === "en") {
        return "I have already registered";
      } else {
        return "قبلاً ثبت نام کرده ام";
      }
    }
    case "firstregister": {
      if (lang.toLowerCase() === "en") {
        return "You must register to use this feature";
      } else {
        return "برای استفاده از این قابلیت باید ثبت نام نمایید";
      }
    }
    case "validatenewpatient": {
      if (lang.toLowerCase() === "en") {
        return "You must register to use this feature";
      } else {
        return "اطلاعات را وارد نمایید نمایید";
      }
    }
    case "helplink": {
      if (lang.toLowerCase() === "en") {
        return "Help me";
      } else {
        return "فرم کمکی";
      }
    }
    case "register": {
      if (lang.toLowerCase() === "en") {
        return "Register";
      } else {
        return "ثبت نام";
      }
    }
    case "attached": {
      if (lang.toLowerCase() === "en") {
        return "Attached";
      } else {
        return "فایلهای الصاقی";
      }
    }
    case "attach": {
      if (lang.toLowerCase() === "en") {
        return "choose file";
      } else {
        return "افزودن فایل";
      }
    }
    case "newforum": {
      if (lang.toLowerCase() === "en") {
        return "you have new message(s) in forum";
      } else {
        return "پیام جدید در بخش بحث و تبادل نظر ثبت شده است";
      }
    }
    case "forgetpassword": {
      if (lang.toLowerCase() === "en") {
        return " Forget password";
      } else {
        return " فراموشی رمز عبور";
      }
    }
    case "forgetpasswordlink": {
      if (lang.toLowerCase() === "en") {
        return "If you have forgotten your password, click here.";
      } else {
        return " اگر رمز عبورتان را فراموش کرده اید اینجا کلیک کنید.";
      }
    }
    case "passwordrecovery": {
      if (lang.toLowerCase() === "en") {
        return "Password recovery";
      } else {
        return "بازیابی رمز عبور";
      }
    }
    case "dayago": {
      if (lang.toLowerCase() === "en") {
        return "Day(s) ago";
      } else {
        return "روز قبل";
      }
    }
    case "monago": {
      if (lang.toLowerCase() === "en") {
        return "Mon(s) ago";
      } else {
        return "ماه قبل";
      }
    }
    case "showcalendar": {
      if (lang.toLowerCase() === "en") {
        return "Show calendar";
      } else {
        return "نمایش تقویم";
      }
    }
    case "hidecalendar": {
      if (lang.toLowerCase() === "en") {
        return "Hide calendar";
      } else {
        return " مخفی کردن تقویم";
      }
    }
    case "yearago": {
      if (lang.toLowerCase() === "en") {
        return "Year(s) ago";
      } else {
        return "سال قبل";
      }
    }
    case "newcolleague": {
      if (lang.toLowerCase() === "en") {
        return "you have a new file from another user";
      } else {
        return "یک فایل جدید برای شما ارسال شده است";
      }
    }
    case "update": {
      if (lang.toLowerCase() === "en") {
        return "Update information";
      } else {
        return "بروزرسانی اطلاعات";
      }
    }
    case "selectedgroup": {
      if (lang.toLowerCase() === "en") {
        return "Selected Group";
      } else {
        return "گروه انتخاب شده";
      }
    }
    case "list": {
      if (lang.toLowerCase() === "en") {
        return "List";
      } else {
        return "لیست ";
      }
    }
    case "listoffiles": {
      if (lang.toLowerCase() === "en") {
        return "List of files";
      } else {
        return "لیست فایل ها";
      }
    }
    case "formnotexist": {
      if (lang.toLowerCase() === "en") {
        return "There is no form information";
      } else {
        return "اطلاعات فرم وجود ندارد";
      }
    }
    case "exitconfirm": {
      if (lang.toLowerCase() === "en") {
        return "Would you like to exit your user profile?";
      } else {
        return "آیا مایل به خروج از پروفایل کاربری خود هستید؟";
      }
    }

    case "displaysummary": {
      if (lang.toLowerCase() === "en") {
        return "Display file's summary";
      } else {
        return "نمایش خلاصه پرونده";
      }
    }
    case "summary": {
      if (lang.toLowerCase() === "en") {
        return "Summary";
      } else {
        return "خلاصه پرونده";
      }
    }
    case "down": {
      if (lang.toLowerCase() === "en") {
        return "Move Down";
      } else {
        return "برو پایین";
      }
    }
    case "up": {
      if (lang.toLowerCase() === "en") {
        return "Move Up";
      } else {
        return "برو بالا";
      }
    }
    case "pages": {
      if (lang.toLowerCase() === "en") {
        return "Pages";
      } else {
        return "صفحه ها";
      }
    }
    case "deleteconfirm": {
      if (lang.toLowerCase() === "en") {
        return "Do you want to delete?";
      } else {
        return "آیا برای حذف آیتم مورد نظر مطمئن هستید؟";
      }
    }
    case "confirmButtonText": {
      if (lang.toLowerCase() === "en") {
        return "Yes, delete it!";
      } else {
        return "بله، موافقم";
      }
    }
    case "delete": {
      if (lang.toLowerCase() === "en") {
        return "Delete";
      } else {
        return "حذف";
      }
    }
    case "addtocopylist": {
      if (lang.toLowerCase() === "en") {
        return "add to copy list";
      } else {
        return "فزودن به لیست کپی";
      }
    }
    case "deletesuccessful": {
      if (lang.toLowerCase() === "en") {
        return "Delete Successfully";
      } else {
        return "حذف با موفقیت انجام شد";
      }
    }
    case "yes": {
      if (lang.toLowerCase() === "en") {
        return "Yes";
      } else {
        return "بله";
      }
    }
    case "groups": {
      if (lang.toLowerCase() === "en") {
        return "Groups";
      } else {
        return "گروه ها";
      }
    }
    case "condition": {
      if (lang.toLowerCase() === "en") {
        return "Condition";
      } else {
        return "شرط";
      }
    }

    case "subformcondition": {
      if (lang.toLowerCase() === "en") {
        return "Conditions for subforms";
      } else {
        return "شروط برای رفتن به فرم فرعی ";
      }
    }
    case "opertators": {
      if (lang.toLowerCase() === "en") {
        return "Opertators";
      } else {
        return "عملگرها";
      }
    }

    case "sendcondition": {
      if (lang.toLowerCase() === "en") {
        return "send conditions";
      } else {
        return "شروط ارسال";
      }
    }
    case "conditions": {
      if (lang.toLowerCase() === "en") {
        return "Conditions";
      } else {
        return "شروط";
      }
    }
    case "quescondition": {
      if (lang.toLowerCase() === "en") {
        return "Question Condition";
      } else {
        return " شرط سوال";
      }
    }
    case "diseases": {
      if (lang.toLowerCase() === "en") {
        return "Book review";
      } else {
        return "مرور کتاب";
      }
    }
    case "scores": {
      if (lang.toLowerCase() === "en") {
        return "Scores";
      } else {
        return "شاخص های امتیازدهی";
      }
    }
    case "nextstep": {
      if (lang.toLowerCase() === "en") {
        return "Next Step";
      } else {
        return "مرحله بعد";
      }
    }

    case "addnewvg": {
      if (lang.toLowerCase() === "en") {
        return "Add new virtual group";
      } else {
        return "افزودن گروه مجازی جدید";
      }
    }
    case "editvg": {
      if (lang.toLowerCase() === "en") {
        return "Edit virtual group";
      } else {
        return "ویرایش گروه مجازی ";
      }
    }

    case "clinics": {
      if (lang.toLowerCase() === "en") {
        return "Clinics";
      } else {
        return " طرح های پژوهشی";
      }
    }
    case "addnewclinic": {
      if (lang.toLowerCase() === "en") {
        return "Add new CLINIC";
      } else {
        return "افزودن کلینیک جدید";
      }
    }
    case "editclinic": {
      if (lang.toLowerCase() === "en") {
        return "Edit CLINIC";
      } else {
        return "ویرایش کلینیک ";
      }
    }
    case "onlyonecondition": {
      if (lang.toLowerCase() === "en") {
        return "Only one condition can be defined for this section";
      } else {
        return "برای این بخش فقط یک شرط می توان تعریف کرد";
      }
    }
    case "recordpatientinfo": {
      if (lang.toLowerCase() === "en") {
        return "Record patient information";
      } else {
        return "ثبت اطلاعات بیمار";
      }
    }
    case "subcapsule": {
      if (lang.toLowerCase() === "en") {
        return "This is a sub capsule for";
      } else {
        return "زیر کپسول برای ";
      }
    }
    case "Keywords": {
      if (lang.toLowerCase() === "en") {
        return "Keyword(s)";
      } else {
        return "کلمات کلیدی ";
      }
    }
    case "selectcomment": {
      if (lang.toLowerCase() === "en") {
        return "Select comment";
      } else {
        return "انتخاب به عنوان تایید شده";
      }
    }
    case "comment": {
      if (lang.toLowerCase() === "en") {
        return "Comment";
      } else {
        return "توضیح";
      }
    }
    case "unselectcomment": {
      if (lang.toLowerCase() === "en") {
        return "Unselect comment";
      } else {
        return "خارج کردن از وضعیت تایید شده";
      }
    }
    case "errormandatory": {
      if (lang.toLowerCase() === "en") {
        return "Required field";
      } else {
        return "فیلد اجباری";
      }
    }
    case "mandatory": {
      if (lang.toLowerCase() === "en") {
        return "Mandatory";
      } else {
        return "اجباری";
      }
    }
    case "gohelppage": {
      if (lang.toLowerCase() === "en") {
        return "Help page";
      } else {
        return "صفحه کمکی";
      }
    }
    case "gonextpage": {
      if (lang.toLowerCase() === "en") {
        return "Go next page";
      } else {
        return "صفحه بعدی";
      }
    }
    case "emptymode": {
      if (lang.toLowerCase() === "en") {
        return "Special empty menu";
      } else {
        return "منو ویژه حالت خالی";
      }
    }

    case "displaytitle": {
      if (lang.toLowerCase() === "en") {
        return "Display the title on the page";
      } else {
        return "نمایش عنوان در صفحه";
      }
    }
    case "fixBottom": {
      if (lang.toLowerCase() === "en") {
        return "Fix buttom";
      } else {
        return "چسباندن به پایین صفحه";
      }
    }
    case "fixtop": {
      if (lang.toLowerCase() === "en") {
        return "Fix top";
      } else {
        return "چسباندن به بالای صفحه";
      }
    }
    case "createcopylist": {
      if (lang.toLowerCase() === "en") {
        return "Create a copy list";
      } else {
        return "ایجاد لیست کپی";
      }
    }
    case "allowcopy": {
      if (lang.toLowerCase() === "en") {
        return "Allow Copy";
      } else {
        return "اجازه کپی";
      }
    }
    case "copylist": {
      if (lang.toLowerCase() === "en") {
        return "copy list";
      } else {
        return "لیست کپی";
      }
    }

    case "gobackpage": {
      if (lang.toLowerCase() === "en") {
        return "Go back page";
      } else {
        return "صفحه قبلی";
      }
    }
    case "showforuser": {
      if (lang.toLowerCase() === "en") {
        return "Show for user";
      } else {
        return "نمایش برای کاربر";
      }
    }
    case "errors": {
      if (lang.toLowerCase() === "en") {
        return "error(s)";
      } else {
        return "خطا";
      }
    }
    case "no": {
      if (lang.toLowerCase() === "en") {
        return "No";
      } else {
        return "خیر";
      }
    }
    case "answernotinrange": {
      if (lang.toLowerCase() === "en") {
        return "Answer not in range";
      } else {
        return "عدد وارد شده در بازه مورد تایید نمی باشد";
      }
    }
    case "probleminproccess": {
      if (lang.toLowerCase() === "en") {
        return "There was a problem with the process, please try again";
      } else {
        return "مشکلی در انجام فرایند رخ داده است لطفا مجددا اقدام نمایید";
      }
    }
    case "emptyalert": {
      if (lang.toLowerCase() === "en") {
        return "Empty field error";
      } else {
        return "خطای فیلد خالی";
      }
    }
    case "parantezalert": {
      if (lang.toLowerCase() === "en") {
        return "Wrong parenthesis error";
      } else {
        return "خطای پرانتز اشتباه";
      }
    }
    case "emailformat": {
      if (lang.toLowerCase() === "en") {
        return "Email format is incorrect";
      } else {
        return "فرمت ایمیل درست وارد نشده است";
      }
    }
    case "cellformat": {
      if (lang.toLowerCase() === "en") {
        return "mobile format is incorrect";
      } else {
        return "فرمت موبایل درست وارد نشده است";
      }
    }
    case "submit": {
      if (lang.toLowerCase() === "en") {
        return "Submit";
      } else {
        return "ثبت";
      }
    }
    case "subformmess": {
      if (lang.toLowerCase() === "en") {
        return "No sub-forms have been designed for this clinic";
      } else {
        return "هیچ فرم فرعی برای این کلینیک طراحی نشده است.";
      }
    }
    case "validatesubform": {
      if (lang.toLowerCase() === "en") {
        return "Please select sub form";
      } else {
        return "لطفا فرم فرعی را انتخاب کنید";
      }
    }
    case "validateformula": {
      if (lang.toLowerCase() === "en") {
        return "formula/question can not be empty";
      } else {
        return "فرمول/سوال نمی تواند خالی باشد";
      }
    }
    case "formatformula": {
      if (lang.toLowerCase() === "en") {
        return "formula/question format is incorrect";
      } else {
        return "فرمت فرمول یا سوال صحیح نیست";
      }
    }
    case "gettoknow": {
      if (lang.toLowerCase() === "en") {
        return "How did you get to know the application?";
      } else {
        return "چگونه با برنامه آشنا شدید؟";
      }
    }
    case "institution": {
      if (lang.toLowerCase() === "en") {
        return "Institution";
      } else {
        return "موسسه/نهاد";
      }
    }

    case "institutionalert": {
      if (lang.toLowerCase() === "en") {
        return "Please enter institution";
      } else {
        return "لطفا موسسه/نهاد را وارد کنید";
      }
    }
    case "nationality": {
      if (lang.toLowerCase() === "en") {
        return "Nationality";
      } else {
        return "ملیت";
      }
    }
    case "email": {
      if (lang.toLowerCase() === "en") {
        return "Email";
      } else {
        return "آدرس ایمیل";
      }
    }
    case "emailalert": {
      if (lang.toLowerCase() === "en") {
        return "Please enter your email address correctly";
      } else {
        return "لطفا آدرس ایمیل خود را بشکل صحیح وارد کنید";
      }
    }
    case "personnelcodealert": {
      if (lang.toLowerCase() === "en") {
        return "Please enter your Personnel Code";
      } else {
        return "لطفا کد پرسنلی خود را وارد کنید";
      }
    }
    case "fullnamealert": {
      if (lang.toLowerCase() === "en") {
        return "Please enter your first and last name";
      } else {
        return "لطفا نام و نام خانوادگی خود را وارد کنید";
      }
    }
    case "inserfirstnamealert": {
      if (lang.toLowerCase() === "en") {
        return "Please enter first  name";
      } else {
        return "لطفا نام    را وارد کنید";
      }
    }
    case "inserlastnamealert": {
      if (lang.toLowerCase() === "en") {
        return "Please enter last name";
      } else {
        return "لطفا  نام خانوادگی  را وارد کنید";
      }
    }
    case "chooseimage": {
      if (lang.toLowerCase() === "en") {
        return "Please select a photo";
      } else {
        return "لطفا عکس انتخاب کنید";
      }
    }
    case "completeprofile": {
      if (lang.toLowerCase() === "en") {
        return "Please complete your profile";
      } else {
        return "لطفا اطلاعات کاربری خود را کامل کنید";
      }
    }
    case "enterusername": {
      if (lang.toLowerCase() === "en") {
        return "Please enter your username";
      } else {
        return "لطفا نام کاربری خود را وارد نمائید";
      }
    }
    case "enterpassword": {
      if (lang.toLowerCase() === "en") {
        return "Please enter your password";
      } else {
        return "لطفا رمز عبور خود را وارد نمائید";
      }
    }
    case "newuser": {
      if (lang.toLowerCase() === "en") {
        return "Sign up here, for the new user";
      } else {
        return "ثبت نام کنید";
      }
    }
    case "newpatient": {
      if (lang.toLowerCase() === "en") {
        return "New patient";
      } else {
        return "ثبت بیمار جدید";
      }
    }
    case "internetwarning": {
      if (lang.toLowerCase() === "en") {
        return "No internet connection";
      } else {
        return "عدم اتصال به اینترنت";
      }
    }
    case "warningalert": {
      if (lang.toLowerCase() === "en") {
        return "A problem has occurred. Please try again";
      } else {
        return "مشکلی رخ داده است لطفا مجددا تلاش نمایید";
      }
    }
    case "checkintenetconnection": {
      if (lang.toLowerCase() === "en") {
        return "Please check device access to the Internet";
      } else {
        return "لطفا دسترسی دستگاه به اینترنت را بررسی بفرمایید";
      }
    }
    case "invalidtoken": {
      if (lang.toLowerCase() === "en") {
        return "Please check your user details";
      } else {
        return "مشکل دسترسی به اطلاعات اکانت";
      }
    }
    case "exit": {
      if (lang.toLowerCase() === "en") {
        return "Log out";
      } else {
        return "خروج";
      }
    }
    case "limitedsending": {
      if (lang.toLowerCase() === "en") {
        return "Limited sending";
      } else {
        return "ارسال بشکل محدود";
      }
    }
    case "search": {
      if (lang.toLowerCase() === "en") {
        return "search...";
      } else {
        return "جستجو...";
      }
    }
    case "mysuggestion": {
      if (lang.toLowerCase() === "en") {
        return "My question/suggestion/comment is";
      } else {
        return "سوال / پیشنهاد / مطلب من";
      }
    }
    case "helptext": {
      if (lang.toLowerCase() === "en") {
        return "Help me";
      } else {
        return "کمکم کن";
      }
    }
    case "warning": {
      if (lang.toLowerCase() === "en") {
        return "Warning";
      } else {
        return "هشدار";
      }
    }
    case "savethefilefirst": {
      if (lang.toLowerCase() === "en") {
        return "Please save the file first";
      } else {
        return "لطفا ابتدا فایل را ذخیره کنید";
      }
    }
    case "alertsuccess": {
      if (lang.toLowerCase() === "en") {
        return "Your request was successful";
      } else {
        return "درخواست شما با موفقیت انجام شد";
      }
    }
    case "from": {
      if (lang.toLowerCase() === "en") {
        return "From";
      } else {
        return "از";
      }
    }
    case "age": {
      if (lang.toLowerCase() === "en") {
        return "Age";
      } else {
        return "سن";
      }
    }
    case "speciality": {
      if (lang.toLowerCase() === "en") {
        return "Speciality";
      } else {
        return "تخصص";
      }
    }
    case "gender": {
      if (lang.toLowerCase() === "en") {
        return "Gender";
      } else {
        return "جنسیت";
      }
    }
    case "city": {
      if (lang.toLowerCase() === "en") {
        return "City";
      } else {
        return "شهر";
      }
    }
    case "personnelcode": {
      if (lang.toLowerCase() === "en") {
        return "Personnel code";
      } else {
        return "کد پرسنلی";
      }
    }
    case "cellnumberwihtoutzero": {
      if (lang.toLowerCase() === "en") {
        return "phone number without zero";
      } else {
        return "شماره موبایل بدون صفر";
      }
    }
    case "country": {
      if (lang.toLowerCase() === "en") {
        return "Country";
      } else {
        return "کشور";
      }
    }
    case "signin": {
      if (lang.toLowerCase() === "en") {
        return "Signin";
      } else {
        return "ورود";
      }
    }
    case "sign-in": {
      if (lang.toLowerCase() === "en") {
        return "Sign in";
      } else {
        return "ورود";
      }
    }
    case "signupreg": {
      if (lang.toLowerCase() === "en") {
        return "Create a new account";
      } else {
        return "ایجاد حساب کاربری جدید";
      }
    }

    case "signup": {
      if (lang.toLowerCase() === "en") {
        return "Signup";
      } else {
        return "ثبت نام";
      }
    }
    case "profile": {
      if (lang.toLowerCase() === "en") {
        return "Profile";
      } else {
        return "اطلاعات کاربری";
      }
    }
    case "changelang": {
      if (lang.toLowerCase() === "en") {
        return "Change language";
      } else {
        return "تغییر زبان";
      }
    }
    case "edit": {
      if (lang.toLowerCase() === "en") {
        return "Edit";
      } else {
        return "ویرایش ";
      }
    }
    case "editprofile": {
      if (lang.toLowerCase() === "en") {
        return "Edit profile";
      } else {
        return "ویرایش اطلاعات کاربری";
      }
    }
    case "ABBILAR": {
      if (lang.toLowerCase() === "en") {
        return "ABBILAR";
      } else {
        return "ABBILAR ";
      }
    }
    case "notification": {
      if (lang.toLowerCase() === "en") {
        return "Notifications";
      } else {
        return "اعلان ها";
      }
    }
    case "pleaseenterphone0": {
      if (lang.toLowerCase() === "en") {
        return "Please enter phone number without code or zero";
      } else {
        return "لطفا شماره موبایل را بدون صفر و کد کشور وارد نمایید";
      }
    }
    case "pleaseenterphone": {
      if (lang.toLowerCase() === "en") {
        return "Please enter the phone number correctly";
      } else {
        return "لطفا شماره موبایل را بشکل صحیح وارد نمایید";
      }
    }
    case "enterpassword": {
      if (lang.toLowerCase() === "en") {
        return "Please enter password";
      } else {
        return "لطفا رمزعبور وارد نمایید";
      }
    }
    case "invalidUser": {
      if (lang.toLowerCase() === "en") {
        return "Invalid username or password";
      } else {
        return "اطلاعات کاربری نامعتبر است";
      }
    }
    case "username": {
      if (lang.toLowerCase() === "en") {
        return "Username";
      } else {
        return "نام کاربری";
      }
    }
    case "withoutlogin": {
      if (lang.toLowerCase() === "en") {
        return "Use without registration and login";
      } else {
        return "استفاده از اپلیکیشن بدون ثبت نام و ورود";
      }
    }

    case "entercellasusername": {
      if (lang.toLowerCase() === "en") {
        return "Enter your mobile number as your username";
      } else {
        return "شماره موبایل خود را به عنوان نام کاربری وارد کنید";
      }
    }
    case "restorepassword": {
      if (lang.toLowerCase() === "en") {
        return "Restore password";
      } else {
        return "بازیابی رمزعبور";
      }
    }
    case "cellnumber": {
      if (lang.toLowerCase() === "en") {
        return "Phone number";
      } else {
        return "شماره تلفن همراه";
      }
    }
    case "ponenumber": {
      if (lang.toLowerCase() === "en") {
        return "Phone";
      } else {
        return " تلفن ";
      }
    }
    case "male": {
      if (lang.toLowerCase() === "en") {
        return "Male";
      } else {
        return "مرد";
      }
    }
    case "female": {
      if (lang.toLowerCase() === "en") {
        return "Female";
      } else {
        return "زن";
      }
    }
    case "password": {
      if (lang.toLowerCase() === "en") {
        return "Password";
      } else {
        return "رمزعبور";
      }
    }
    case "login": {
      if (lang.toLowerCase() === "en") {
        return "Login";
      } else {
        return "ورود";
      }
    }
    case "loginmenu": {
      if (lang.toLowerCase() === "en") {
        return "Login";
      } else {
        return "ورود به حساب کاربری";
      }
    }
    case "getdatas": {
      if (lang.toLowerCase() === "en") {
        return "Loading datas ...";
      } else {
        return "درحال دریافت اطلاعات";
      }
    }

    case "setting": {
      if (lang.toLowerCase() === "en") {
        return "Settings";
      } else {
        return "تنظیمات";
      }
    }
    case "fullname": {
      if (lang.toLowerCase() === "en") {
        return "Full name";
      } else {
        return "نام و نام خانوادگی";
      }
    }
    case "name": {
      if (lang.toLowerCase() === "en") {
        return "name";
      } else {
        return "نام";
      }
    }
    case "family": {
      if (lang.toLowerCase() === "en") {
        return "family";
      } else {
        return "نام خانوادگی";
      }
    }
    case "infavorite": {
      if (lang.toLowerCase() === "en") {
        return "menu is in favorite mode";
      } else {
        return "در حالت موردعلاقه قرار گرفت";
      }
    }
    case "menu": {
      if (lang.toLowerCase() === "en") {
        return "Menu";
      } else {
        return "منو";
      }
    }
    case "outfavorite": {
      if (lang.toLowerCase() === "en") {
        return "Out of favorite mode";
      } else {
        return "از حالت موردعلاقه خارج شد";
      }
    }
    case "cancel": {
      if (lang.toLowerCase() === "en") {
        return "Cancel";
      } else {
        return "انصراف";
      }
    }
    case "continue": {
      if (lang.toLowerCase() === "en") {
        return "Continue";
      } else {
        return "ادامه";
      }
    }
    case "save": {
      if (lang.toLowerCase() === "en") {
        return "Save";
      } else {
        return "ذخیره";
      }
    }
    case "share": {
      if (lang.toLowerCase() === "en") {
        return "Share";
      } else {
        return "به اشتراک گذاری";
      }
    }
    case "sendtoforum": {
      if (lang.toLowerCase() === "en") {
        return "Send to forum";
      } else {
        return "ارسال برای انجمن";
      }
    }
    case "sendtocollegue": {
      if (lang.toLowerCase() === "en") {
        return "Send to collegue";
      } else {
        return "ارسال برای همکاران";
      }
    }
    case "nationalcode": {
      if (lang.toLowerCase() === "en") {
        return "code";
      } else {
        return "کد";
      }
    }
    case "invalidnationalcode": {
      if (lang.toLowerCase() === "en") {
        return "Invalid code";
      } else {
        return "کد  نامعتبر";
      }
    }
    case "birthyear": {
      if (lang.toLowerCase() === "en") {
        return "Birth year";
      } else {
        return "سال تولد";
      }
    }
    case "birthdate": {
      if (lang.toLowerCase() === "en") {
        return "Birth Date";
      } else {
        return "تاریخ تولد";
      }
    }
    case "unsavedfile": {
      if (lang.toLowerCase() === "en") {
        return "Unsaved file";
      } else {
        return "فایل ذخیره نشده";
      }
    }
    case "showfilebyadmin": {
      if (lang.toLowerCase() === "en") {
        return "Show file in forum by admin";
      } else {
        return "نمایش فایل در فرم توسط مدیر";
      }
    }
    case "deletefilebyadmin": {
      if (lang.toLowerCase() === "en") {
        return "Delete file from forum by admin";
      } else {
        return "حذف فایل از فرم توسط مدیر";
      }
    }
    case "deletefileafterday": {
      if (lang.toLowerCase() === "en") {
        return "Delete file from forum after day";
      } else {
        return "  مدت زمان حذف فایل از فرم (روز) ";
      }
    }
    case "deletefileafterhour": {
      if (lang.toLowerCase() === "en") {
        return "Delete file from forum after hour";
      } else {
        return " مدت زمان حذف فایل از فرم (ساعت) ";
      }
    }
    case "Relocation": {
      if (lang.toLowerCase() === "en") {
        return "Displacement was applied";
      } else {
        return "جابجایی اعمال شد ";
      }
    }
    case "insertbirthyear": {
      if (lang.toLowerCase() === "en") {
        return "Insert Birth year";
      } else {
        return " سال تولد را وارد کنید";
      }
    }
    case "invalidanswervalue": {
      if (lang.toLowerCase() === "en") {
        return "Invalid answer value";
      } else {
        return " مقدار پاسخ نامعتبر است";
      }
    }
    case "userlist": {
      if (lang.toLowerCase() === "en") {
        return "User's list";
      } else {
        return "لیست کاربران";
      }
    }
    case "filepermisions": {
      if (lang.toLowerCase() === "en") {
        return "file permisions";
      } else {
        return "مدیریت دسترسی فایل ها";
      }
    }
    case "formpermisions": {
      if (lang.toLowerCase() === "en") {
        return "form permisions";
      } else {
        return "مدیریت دسترسی فرم ها";
      }
    }
    case "virtualgroups": {
      if (lang.toLowerCase() === "en") {
        return "Virtual Groups";
      } else {
        return "گروه های مجازی";
      }
    }
  }
};
export default getText;
